import { connect } from 'react-redux';

import {
  changeRevenueView,
  setRevenueColumnChartSorting,
  toggleRevenueAdaptive,
  toggleRevenueAverageLine,
  toggleRevenueCalcTotal,
  toggleRevenueMedianLine,
  toggleRevenueTrendLine,
} from '../../../../../actions/dashboards/revenue';
import {
  getDashboardRevenueOptions,
  getDashboardsRevenueGroupColumn,
} from '../../../../../reducers/analyticsApp';
import ExecutionOptionsBar from '../../../../../components/common/ExecutionOptionsBar';
import {
  changeAdaptive,
  onChangeSorting,
  toggleAverage,
  toggleGrandTotal,
  toggleMedian,
  toggleTrend,
} from '../../../../../actions/chart';
import { getView, getViews } from './revenueOptionsBarUtils';

const mapStateToProps = (state, { unit }) => {
  const groupColumn = getDashboardsRevenueGroupColumn(state, unit.id);
  const options = getDashboardRevenueOptions(state, unit.id);
  const currentView = options.view;
  const view = getView(currentView, groupColumn);

  return {
    options: {
      ...options,
      view,
      views: getViews(groupColumn),
    },
  };
};

const mapDispatchToProps = (dispatch, { unit }) => ({
  onChangeView: (view) => dispatch(changeRevenueView(unit.id, view)),
  onChangeSorting: (sorting) =>
    onChangeSorting(sorting, () => dispatch(setRevenueColumnChartSorting(unit.id, sorting))),
  toggleGrandTotal: (e, columnChartSorting) =>
    toggleGrandTotal(e, columnChartSorting, () => dispatch(toggleRevenueCalcTotal(unit.id))),
  toggleTrendLine: (e) => toggleTrend(e, () => dispatch(toggleRevenueTrendLine(unit.id))),
  toggleAverageLine: (e) => toggleAverage(e, () => dispatch(toggleRevenueAverageLine(unit.id))),
  toggleMedianLine: (e) => toggleMedian(e, () => dispatch(toggleRevenueMedianLine(unit.id))),
  toggleAdaptive: (e) => changeAdaptive(e, () => dispatch(toggleRevenueAdaptive(unit.id))),
});

export default connect(mapStateToProps, mapDispatchToProps)(ExecutionOptionsBar);
